import DOMPurify from 'dompurify';

export default function sanitize(html) {
  return DOMPurify.sanitize(html, {
    ADD_ATTR: ['target', 'dir'],
    ADD_TAGS: ['agentmention', 'placeholder', 'variable'],
  });
}
